module.exports = __webpack_public_path__ + "../resources/img/bg_pv1_03.9e9eeefd.png";